import { jsx as l } from "react/jsx-runtime";
import { c as r } from "../clsx-OuTLNxxd.js";
import { R as d } from "../ResponsiveSanityImage-BfPbiFwC.js";
import { SanityImageRatio as g } from "../ImageRatio/SanityImageRatio.js";
const m = "InlineImage-module_inline-image__dra5E",
  o = "InlineImage-module_align-left__1MMEE",
  h = "InlineImage-module_align-center__zY-x-",
  u = "InlineImage-module_align-right__yVaVa",
  _ = "InlineImage-module_width-quarter__29u0b",
  I = "InlineImage-module_width-third__4nh4f",
  f = "InlineImage-module_width-half__II7QL",
  s = "InlineImage-module_width-full__09H-4",
  e = {
    inlineImage: m,
    alignLeft: o,
    alignCenter: h,
    alignRight: u,
    widthQuarter: _,
    widthThird: I,
    widthHalf: f,
    widthFull: s
  },
  y = _ref => {
    let {
      align: n,
      asset: t,
      width: i
    } = _ref;
    if (!t || !t._ref) return null;
    const a = {
      asset: {
        _id: t._ref
      }
    };
    return /* @__PURE__ */l("div", {
      className: r(e.inlineImage, {
        [e.alignLeft]: n == "left",
        [e.alignCenter]: n == "center",
        [e.alignRight]: n == "right",
        [e.widthQuarter]: i == "quarter",
        [e.widthThird]: i == "third",
        [e.widthHalf]: i == "half",
        [e.widthFull]: i == "full"
      }),
      children: /* @__PURE__ */l(g, {
        image: a,
        ratio: "auto",
        children: /* @__PURE__ */l(d, {
          image: a,
          defaultWidth: 800,
          defaultHeight: 600,
          loading: "lazy"
        })
      })
    });
  };
export { y as InlineImage };